import React from 'react';
import classnames from 'classnames';
import type { ReactNode } from 'react';
import SortLabel, { SortLabelProps } from './SortLabel';
import SortMenuTitle from './SortMenuTitle';
import styles from './index.module.scss';

export type SortMenuProps = {
  title?: ReactNode;
  titleIconXLinkHref?: string;
  className?: string;
  titleClassName?: string;
  titleIconClassName?: string;
  selectedLabelValue?: string;
  onSortLabelClick?: (value: string) => void;
};

const sortLabelList: SortLabelProps[] = [
  {
    name: '字母排序',
    value: 'first_word_asc',
    iconXLinkHref: '#icon-AtoZ',
    selectedIconXLinkHref: 'icon-AtoZ_selected',
  },
  { name: '最新收录', value: 'new_desc' },
  {
    name: '最新更新',
    value: 'update_desc',
    iconXLinkHref: '#icon-latest',
    selectedIconXLinkHref: '#icon-latest_selected',
  },
];

const SortMenu: React.FC<SortMenuProps> = ({
  title,
  titleIconXLinkHref,
  selectedLabelValue,
  className,
  titleClassName,
  titleIconClassName,
  onSortLabelClick,
}) => {
  return (
    <>
      <div className={classnames(styles.sortMenu, className)}>
        <SortMenuTitle
          title={title}
          className={titleClassName}
          iconXLinkHref={titleIconXLinkHref}
          iconClassName={titleIconClassName}
        />
        <div className={styles.sortLabelsContainer}>
          {sortLabelList.map(item => (
            <SortLabel
              className={styles.sortLabel}
              key={item.value}
              name={item.name}
              value={item.value}
              iconXLinkHref={item.iconXLinkHref}
              selectedIconXLinkHref={item.selectedIconXLinkHref}
              selected={selectedLabelValue === item.value}
              onClick={onSortLabelClick}
            />
          ))}
        </div>
      </div>
    </>
  );
};

export default SortMenu;
